type Config = {
    baseURL: string | null;
    baseAccountURL: string | null;
};

export const config: Config = {
    baseURL: null,
    baseAccountURL: null,
};

export const initReduxStore = (baseURL: string, baseAccountURL: string) => {
    config.baseURL = baseURL;
    config.baseAccountURL = baseAccountURL;
};
